module.exports = __webpack_public_path__ + "assets/loop-preview-active.cf3ad456.svg";